import { render, staticRenderFns } from "./SavingsAccountForm.vue?vue&type=template&id=6f32d3b8&"
import script from "./SavingsAccountForm.vue?vue&type=script&lang=ts&"
export * from "./SavingsAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports